// eslint-disable-next-line no-restricted-imports
import { Typography } from '@mui/material';
import { getColor } from 'helpers';
import { Pressed, Tooltip } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { ColorsDark, ColorsLight } from 'libs/ui/theme';

export const HintStyled = styled(Pressed)(({ theme }) => ({
  cursor: 'pointer',

  '.hint-info': {
    color: getColor(theme, {
      light: ColorsLight.blue150,
      dark: ColorsDark.blue150,
    }),

    ':hover': {
      color: theme.palette.hover,
    },
  },
}));

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  whiteSpace: 'pre-wrap',
}));

export const TooltipStyled = styled(Tooltip)(({ theme }) => ({
  maxWidth: 504,
  [Tooltip.classes.tooltip.css]: {
    backgroundColor: getColor(theme, {
      light: ColorsLight.blue50,
      dark: ColorsDark.gray100,
    }),
    color: getColor(theme, {
      light: ColorsLight.black,
      dark: ColorsDark.black,
    }),
    padding: '8px 16px',
    borderRadius: 12,
    marginTop: 8,
    maxWidth: 600,
  },

  [Tooltip.classes.arrow.css]: {
    color: getColor(theme, {
      light: ColorsLight.blue50,
      dark: ColorsDark.gray100,
    }),
  },
}));
